import _ from 'lodash';

export const required = value =>
  value || value === 0 ? undefined : 'This field is required.';

// Matches date in the format `DD/MM/YYYY`. Day is [1-31], Month - [1-12], 1900 < YYYY < 3000
export const validBirthDate = value => {
  if (_.isNil(value) || _.isEmpty(value)) return undefined;

  // Validates all dates with DD > 28 by checking months and years
  const datesWithOver28DaysValidDateRegex = /^(?:(?:31\/(?:0?[13578]|1[02]))\/|(?:(?:29|30)\/(?:0?[13-9]|1[0-2])\/))(?:(?:19|2\d)\d\d)$/;
  // Validates 29 days in february if the year is a leap year
  const leapYearFebrurayValidDateRegex = /^(?:29\/0?2\/(?:(?:(?:19|2\d)(?:0[48]|[2468][048]|[13579][26])|(?:2[048]00))))$/;
  // Validates every date format with days < 28
  const validDateWithUnder28DaysRegex = /^(?:0?[1-9]|1\d|2[0-8])\/(?:(?:0?[1-9])|(?:1[0-2]))\/(?:(?:19|2\d)\d\d)$/;

  const valid =
    datesWithOver28DaysValidDateRegex.test(value) ||
    leapYearFebrurayValidDateRegex.test(value) ||
    validDateWithUnder28DaysRegex.test(value);

  return valid ? undefined : 'Invalid date';
};

// Matches date in the format `DD/MM/YYYY`. Day is [1-31], Month - [1-12], Year is > 2000
export const validDate = value => {
  if (_.isNil(value) || _.isEmpty(value)) return undefined;

  const validateDateOver2000 = /^\d?\d\/\d?\d\/2\d\d\d$/;

  if (validateDateOver2000.test(value)) {
    return validBirthDate(value);
  }

  return 'Invalid date';
};

export const validEmail = value => {
  if (_.isNil(value) || _.isEmpty(value)) return undefined;

  // const valid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value);
  // disabled - as we want to support tc.rocks emails
  /* prettier-ignore */
  const valid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value);

  return valid ? undefined : 'Invalid email';
};

export const positiveInteger = value => {
  const n = parseInt(value, 10);

  if (n <= 0) {
    return 'Value should be a positive integer greater than 0.';
  }

  return undefined;
};

export const nonRequiredPositiveInteger = value => {
  if (_.isNil(value) || _.isEmpty(value)) return undefined;

  return positiveInteger(value);
};

export const validHour = value => {
  const valid = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/i.test(value);

  return valid ? undefined : 'Invalid hour';
};
